import { Component, OnInit } from '@angular/core';

import { OkAloneService } from 'src/app/ok-alone.service';

import moment from 'moment';

@Component({
  selector: 'app-shifts',
  templateUrl: './shifts.component.html',
  styleUrls: ['./shifts.component.scss']
})

export class ShiftsComponent implements OnInit {

  shifts : any;
  view : any;
  selected : any;
  filter : any;
  worker_id : any;
  group : any;
  search : any;
  sort = 'newest';

  pagination = { page: 1, pageSize: 1, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };

  constructor(public okService: OkAloneService) { }
  
  ngOnInit(): void {

    this.pagination.page = 1;
    this.selected = { startDate: moment().subtract(1,'months'), endDate: moment() }

    this.getShifts();

  }

  getShifts(){

    // console.log('filter', this.filter);
    
    this.updateFilter();

    this.okService.get("shifts",this.filter)
    .subscribe((data) => {

      this.shifts = data.body;
      this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;

    });

  }

  changePage(){
    this.getShifts();
  }

  updateFilter(){

    this.filter = [];
    
    this.filter['start'] = this.selected.startDate.format("YYYY-MM-DD");
    this.filter['end'] = this.selected.endDate.format("YYYY-MM-DD");

    this.filter['page'] = this.pagination.page;

    if(this.search){
      this.filter['search'] = this.search;
    }

    if(this.worker_id){
      this.filter['worker_id'] = this.worker_id;
    }

    if(this.group){
      this.filter['group'] = this.group;
    }

    this.filter['sort'] = this.sort;

  }

  clearFilter(){
    this.filter = [];
    this.selected = { startDate: moment().subtract(1, 'months'), endDate: moment() };
    this.worker_id = null;
    this.group = null;
    this.updateFilter();
    this.getShifts();
  }

  exportShifts(){

    this.updateFilter();
    // this.filter['expand'] = 'pins,locations';

    this.okService.download("shifts/export",this.filter);

  }

}
